<template>
  <div
    class="c-video-upgrade"
    :class="{'visible' : toggle}"
  >
    <div class="c-video-upgrade__body p-3">
      <div class="white me-2 flex-grow-1">
        <p class="fs-16 w-bold mb-1">
          ¡Recuerda que el acceso gratuito tiene tiempo
          limitado y no incluye certificado!
        </p>
        <p class="fs-14 w-medium mb-3">
          Con un solo pago certificate y accede a más de 100 cursos.
        </p>
        <a
          href="/planes"
          class="c-button c-button--dark small d-inline-block"
        >
          Ver planes
        </a>
      </div>
      <button
        class="c-link c-link--white-full fs-21 d-flex align-items-center"
        @click="close()"
      >
        <Icon icon="ci:close-big" />
      </button>
    </div>
    <div class="c-video-upgrade__progress">
      <div
        class="c-video-upgrade__progress-percentage"
        :style="`width: ${percentage}%`"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      intervalTimer: null,
      percentage: 0,
    };
  },
  props: {
    toggle: Boolean,
  },
  watch: {
    percentage(value) {
      if (value >= 100) {
        this.finishPercentageTime();
      }
    },
  },
  mounted() {
    window.setInterval(() => {
      if (!this.intervalTimer) {
        if (localStorage.getItem('arcux_adarcux_date')) {
          const lastAdarcuxDate = new Date(localStorage.getItem('arcux_adarcux_date'));
          const currentDate = new Date();
          const timeDifference = Math.abs(currentDate - lastAdarcuxDate) / 1000;

          if (timeDifference >= 60) {
            this.initAdvertisement();
          }
        } else {
          localStorage.setItem('arcux_adarcux_date', new Date());
        }
      }
    }, 1000);
  },
  methods: {
    close() {
      localStorage.setItem('arcux_adarcux_date', new Date());

      this.$emit('update:toggle', false);
    },
    initAdvertisement() {
      this.percentage = 0;
      this.$emit('update:toggle', true);

      this.intervalTimer = window.setInterval(() => {
        this.percentage += 1;
      }, 100);
    },
    finishPercentageTime() {
      window.clearInterval(this.intervalTimer);

      this.intervalTimer = null;
      this.close();
    },
  },
};
</script>
